<template>
    <div id="renewal-check-modal"
         class="modal fade renewal-check-modal"
         data-bs-keyboard="false"
         tabindex="-1"
         aria-labelledby="renewalCheckModalLabel"
         aria-hidden="true"
    >
        <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="renewalCheckModalLabel">
                        Is jouw contract vrij? Check het hier!
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <loader
                        :loading="loading"
                        text="De einddatum van jouw abonnement word opgezocht. Een moment geduld alsjeblieft."
                    />

                    <div class="renewal-check-form-wrapper">
                        <div class="information-section">
                            <p class="mb-3">
                                Als jouw mobiele contract vrij is, kun je overstappen of verlengen. Je krijgt dan vaak
                                grote korting op je nieuwe smartphone en abonnement.
                                Indien je kiest voor een nieuwe Sim-Only ontvang je van ons vaak een cashback of een
                                cadeau.
                            </p>

                            <p>
                                Vul onze verlengingschecker in en wij zoeken het direct voor je uit! Wij helpen je eraan
                                herinneren zodra je kunt verlengen of overstappen.
                                Je kunt je op elk moment weer afmelden van deze service.
                            </p>
                        </div>

                        <form class="form">
                            <div class="container-fluid">
                                <div class="row mb-3 client-type-section">
                                    <div class="col-md-3">
                                        <label>Type klant</label>
                                    </div>

                                    <div class="col-md-9">
                                        <div class="d-flex justify-content-end">
                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model="customer.is_business"
                                                    class="form-check-input"
                                                    type="radio" name="is_business"
                                                    id="is-business-radio1" :value="0"
                                                    :checked="customer.is_business === 0"
                                                >
                                                <label class="form-check-label" for="is-business-radio1">
                                                    Particulier
                                                </label>
                                            </div>

                                            <div class="form-check form-check-inline">
                                                <input
                                                    v-model="customer.is_business"
                                                    class="form-check-input"
                                                    type="radio" name="is_business"
                                                    id="is-business-radio2" :value="1"
                                                    :checked="customer.is_business === 1"
                                                >
                                                <label class="form-check-label" for="is-business-radio2">
                                                    Zakelijk
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-content-wrap">
                                    <div v-if="hasError" class="alert alert-danger mb-4">
                                        Op dit moment krijgen wij geen inzicht in de datum waarop je bij {{ renewalData.provider_name }} kunt verlengen.
                                        Je kunt, indien je dat wenst, wel gewoon een bestelling plaatsen. De bestelling lukt als een
                                        verlenging of overstap met nummerbehoud mogelijk is. Indien dat nog niet kan,
                                        ontvangen wij de einddatum van jouw contract. Die laten we aan je weten.
                                    </div>

                                    <div v-if="hasSuccess && renewalData.is_renewable" class="alert alert-success mb-4">
                                        Goed nieuws, je kunt direct verlengen.
                                    </div>

                                    <div v-if="hasSuccess && !renewalData.is_renewable" class="alert alert-success mb-4">
                                        Nog even geduld, je kunt verlengen vanaf {{ renewalData.renew_date }}. Zodra je kunt verlengen brengen wij je direct op de hoogte.
                                    </div>

                                    <div v-if="customer.is_business" class="form-group mb-3">
                                        <label for="company-name">Bedrijfsnaam</label>
                                        <input
                                            v-model="customer.company_name"
                                            id="company-name" type="text"
                                            name="company_name" class="form-control"
                                            placeholder="Bedrijfsnaam" autocomplete="chrome-off"
                                        />
                                    </div>

                                    <div class="form-group mb-3">
                                        <label for="phone">Mobiel nummer</label>
                                        <input
                                            v-model="customer.phone_number"
                                            id="phone" type="tel"
                                            name="phone" class="form-control"
                                            max="10"
                                            placeholder="Mobiel nummer"
                                            required
                                        >
                                    </div>

                                    <div class="form-group mb-3">
                                        <label for="birth_date">Geboortedatum</label>
                                        <input
                                            v-model="customer.birth_date"
                                            v-maska
                                            data-maska="##-##-####"
                                            id="birth_date"
                                            placeholder="Geboortedatum"
                                            class="form-control"
                                            required
                                        />
                                    </div>

                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group">
                                                <label for="postal-code">Postcode</label>
                                                <input
                                                    v-model="customer.postal_code"
                                                    id="postal-code" type="text"
                                                    name="postal_code" class="form-control"
                                                    placeholder="Postcode" pattern="[0-9]{4}\s?[a-zA-Z]{2}"
                                                    size="7" maxlength="7" required
                                                >
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="form-group mb-3">
                                                <label for="house-number">Huisnummer (zonder toevoeging)</label>
                                                <input
                                                    v-model="customer.house_number"
                                                    id="house-number" type="number"
                                                    name="house_number" class="form-control"
                                                    placeholder="Huisnummer" required
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div v-if="false" class="col-12 col-md-6">
                                            <div class="form-group mb-3">
                                                <label for="password">Password</label>
                                                <input
                                                    v-model="customer.password"
                                                    id="password" type="text"
                                                    name="password" class="form-control"
                                                    placeholder="Password"
                                                >
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-12">
                                            <div class="form-group mb-3">
                                                <label for="email" class="h6 small">E-mail</label>
                                                <input
                                                    v-model="customer.email"
                                                    id="email" type="email"
                                                    name="email" class="form-control"
                                                    placeholder="E-mail" required
                                                >
                                            </div>
                                        </div>
                                    </div>

                                    <p class="mb-3">
                                        Door het versturen van dit formulier ga je ermee akkoord dat wij jou per mail
                                        voorzien van
                                        aanbiedingen zodra jouw contract verlengbaar is. Je kunt je hiervoor altijd weer
                                        uitschrijven.
                                    </p>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        type="submit" class="btn btn-dark btn-renewal-check"
                        @click.prevent="onSubmit"
                        :disabled="loading"
                    >
                        Verstuur
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from '@vueform/multiselect'
import Loader from "../Loader"

export default {
    components: {
        Multiselect,
        Loader
    },

    props: {
        providerList: {
            type: Array,
            required: true
        },

        type: {
            type: String,
            default: 'WEBSITE'
        },

        isBusiness: {
            type: Number,
            default: false
        }
    },

    watch: {
        isBusiness: {
            handler(newValue, oldValue) {
                this.customer.is_business = newValue
            },
            immediate: true
        },
    },

    data() {
        return {
            loading: false,
            hasError: false,
            hasSuccess: false,
            customer: {
                is_business: 0,
                company_name: '',
                phone_number: '',
                birth_date: null,
                postal_code: '',
                password: '',
                email: '',
            },
            renewalData: {}
        }
    },

    methods: {
        async onSubmit() {
            this.hasSuccess = false
            this.hasError = false
            this.loading = true

            await axios
                .get(`/api/renewal-check`, {
                    params: {
                        ...this.customer,
                        type: this.type
                    }
                })
                .then(({data}) => {
                    this.hasSuccess = true
                    this.loading = false

                    this.renewalData = {
                        is_renewable: data.is_renewable,
                        renew_date: data.renew_date,
                        provider_name: data.provider_name,
                    }
                })
                .catch((error) => {
                    this.renewalData = {}
                    if (error.response) {
                        this.renewalData = {
                            provider_name: error.response.data.provider_name
                        }
                    }

                    this.hasError = true
                    this.loading = false
                })
        }
    }
}
</script>
